import { useForm as useInertiaForm } from "@inertiajs/react";

export const useForm = (initialValues) => {
    const form = useInertiaForm(initialValues);

    const formProps = (name) => ({
        id: name,
        name: name,
        value: form.data[name] || '',
        onChange: (e) => {
            let value;
            
            if (e && e.target) {
                if (e.target.value !== undefined) {
                    value = e.target.value;
                } else if (e.target.checked !== undefined) {
                    value = e.target.checked;
                } else if (e.target.files !== undefined) {
                    value = e.target.files;
                }
            } else {
                value = e;
            }

            form.setData(name, value);
        },
        error: form.errors[name] || '',
    });

    return {...form, formProps}
}